// Credit pricing constants — MIRROR of backend/src/shared-layer/shared/credits.py.
// Keep in sync: these drive displayed prices, and the backend is what actually
// charges. If a number here disagrees with the backend, the backend wins.

// One-time signup grant for new signed-up users (email or Google).
export const SIGNUP_BONUS_CREDITS = 20;

// Retail price per credit (display only — backend charges via Stripe Price IDs).
export const CREDIT_PRICE_USD = 0.15;

// Flat cost for a transcript scan (no duration → no band).
export const TRANSCRIPT_SCAN_CREDITS = 10;

// Below this, the UI warns that the balance is running low. Set to the cost of
// one Standard (2-10 min) scan — the median case — so the warning means
// "you may not be able to afford your next scan" rather than an arbitrary number.
export const LOW_BALANCE_CREDITS = 10;

// One-shot purchasable pack. `priceCents` lines up with the Stripe Price ID
// configured per-env in template.yaml. `id` is what POST /api/billing/purchase
// expects as `pack_id`. Single pack for v1 — users who need more just buy
// again (no bulk tiers, no custom top-up, no contact-sales gate).
export const CREDIT_PACKS = [
  { id: 'starter', name: 'Credits', credits: 250, priceCents: 499, blurb: '~25 Standard-length scans' },
];

// Scan pricing bands (Model B) — first band whose max the duration is within wins.
// Above the last band: XL_BASE + 1 credit per additional 10 min (rounded up).
export const SCAN_PRICING_BANDS = [
  { maxSeconds: 120, credits: 3, label: 'Short (≤ 2 min)' },
  { maxSeconds: 600, credits: 10, label: 'Standard (2 – 10 min)' },
  { maxSeconds: 1800, credits: 15, label: 'Long (10 – 30 min)' },
  { maxSeconds: 3600, credits: 20, label: 'Extended (30 – 60 min)' },
];
export const XL_BASE_CREDITS = 25;
export const XL_INCREMENT_CREDITS = 1;
export const XL_INCREMENT_SECONDS = 600;

// Rows for the "how scans are priced" table on the pricing page.
export const SCAN_PRICING_ROWS = [
  { length: '≤ 2 min (Short)', credits: '3' },
  { length: '2 – 10 min (Standard)', credits: '10' },
  { length: '10 – 30 min (Long)', credits: '15' },
  { length: '30 – 60 min (Extended)', credits: '20' },
  { length: '> 60 min (XL)', credits: '25 + 1 / extra 10 min' },
];

// pack.priceCents → "$4.99"
export const formatCents = (cents) =>
  `$${(cents / 100).toFixed(2)}`;

// pack → "$0.166 / credit"
export const perCreditPrice = (pack) =>
  `$${(pack.priceCents / 100 / pack.credits).toFixed(3)} / credit`;
